import { render, staticRenderFns } from "./ServiceIcon.vue?vue&type=template&id=2a542d6a&scoped=true&"
import script from "./ServiceIcon.vue?vue&type=script&lang=js&"
export * from "./ServiceIcon.vue?vue&type=script&lang=js&"
import style0 from "./ServiceIcon.vue?vue&type=style&index=0&id=2a542d6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a542d6a",
  null
  
)

export default component.exports